// Pricing组件的入口文件
import Pricing from './Pricing';

export default Pricing;